import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';

import JobListContext from '../../context/jobListContext';
import AssetListContext from '../../context/assetListContext';
import AppStateContext from '../../context/appStateContext';

import DateLabel from '../../../components/dateLabel';
import LocationLabel from '../../../components/locationLabel';
import GenericBubble from '../../../components/genericBubble';
import SlaStatusBubble from '../../../components/slaStatusBubble';
import StatusBubble from '../../../components/statusBubble';
import JobDetailAssetCardList from '../Lists/jobDetailAssetCardList';
import DetailsTable from '../../../components/detailsTable';
import ExportButton from "../../../components/exportButton";
import ApiStatus, {CALLING,EMPTY,POPULATED} from "../../../components/apiStatus";
import { tableData } from "../../../hooks/useFilterHelper";

import GetAssetsListFunction from '../../../functions/GetAssetsListFunction';
import SalesOrderGetSalesOrder from "../../../functions/SalesOrderGetSalesOrders";
import useTextCorrection from '../../../hooks/useTextCorrection';

import {
  AssetDetailList,
  BubbleTitle,
  BubbleSection,
  ContentCtn,
  HeadingDescCtn,
  HeadingDesc,
  JobDetailCtn,
  JobTitle,
  SectionTitle,
  ButtonCtn,
} from './index.style';
import APIHelper from "../../../hooks/useAPIHelper";

const JobDetailReactive: React.FC<any> = (): React.ReactElement => {
  const { selectedReactiveJob, clearSelectedReactiveJob, setAppJobDetails } = useContext(JobListContext);
  const { clearAssetDetails } = useContext(AssetListContext);
  const { token, contractCriticalCode } = useContext(AppStateContext);
  const [currentApiStatus, setCurrentApiStatus] = useState(CALLING);
  const [renderedAsset, setRenderedAsset] = useState([]);

  const { filterText } = useTextCorrection();
  const tableHeadings = tableData['reactive'];
  const getAssetInvoiceInfo = APIHelper();

  const assetCallback = (data: [] | string) => {
    if (data == 'timeout' || data.length == 0) {
      setCurrentApiStatus(EMPTY);
      return;
    }

    setCurrentApiStatus(POPULATED);

    if (typeof data == 'object') {
      setRenderedAsset([data]);
    } else {
      setRenderedAsset(data);
    }
  };

  const invoiceCallback = (data: {}) => {
    setAppJobDetails({
      selectedReactiveJob: _.merge(selectedReactiveJob,data),
    })
  };

  useEffect(() => {
    return () => {
      clearSelectedReactiveJob();
      clearAssetDetails();
    }
  },[]);

  useEffect(() => {
    setCurrentApiStatus(CALLING);

    if(selectedReactiveJob.CallNo == '') {
      setCurrentApiStatus(EMPTY);
      return;
    }

    if(selectedReactiveJob.SerialNo != ''){
      let filter: string = `<Filters><SerialNo><Like>${selectedReactiveJob.SerialNo}</Like></SerialNo></Filters>`;
      getAssetInvoiceInfo.run(GetAssetsListFunction,assetCallback, [filter, token, selectedReactiveJob.ContractNo]);
    }

  }, [selectedReactiveJob.SerialNo]);

  useEffect(() => {
    if (selectedReactiveJob.SOOrderNo != '') {
      let filter = `<SOOrderNo>${selectedReactiveJob.SOOrderNo}</SOOrderNo>`;
      getAssetInvoiceInfo.run(SalesOrderGetSalesOrder, invoiceCallback, [filter,token,selectedReactiveJob.ContractNo]);
    }
  },[selectedReactiveJob.SOOrderNo]);

  return (
    <JobDetailCtn>
      <ContentCtn>
        <JobTitle>{filterText(selectedReactiveJob.CallDescription)}</JobTitle>
        <HeadingDescCtn>
          <HeadingDesc>
            <LocationLabel
              location={
                selectedReactiveJob.CallLocations == undefined
                  ? selectedReactiveJob.AddressName
                  : selectedReactiveJob.CallLocations.CallLocation == undefined
                  ? selectedReactiveJob.AddressName
                  : selectedReactiveJob.CallLocations.CallLocation.LocationDesc
              }
            />
          </HeadingDesc>
          <HeadingDesc>
            <DateLabel
              slaStatus={selectedReactiveJob.SLAComplete}
              date={selectedReactiveJob.SLAOnsiteEstimated + ' ' + selectedReactiveJob.SLAOnsiteEstimatedTime}
            />
          </HeadingDesc>
        </HeadingDescCtn>
        <BubbleSection>
          <div>
            <BubbleTitle>SLA (Onsite)</BubbleTitle>
            <SlaStatusBubble slaStatus={selectedReactiveJob.SLAOnsite}/>
          </div>
          <div>
            <BubbleTitle>SLA (Complete)</BubbleTitle>
            <SlaStatusBubble slaStatus={selectedReactiveJob.SLAComplete}/>
          </div>
          <div>
          <BubbleTitle>Status</BubbleTitle>
          <StatusBubble status={selectedReactiveJob.Status} />
        </div>
          <div>
            <BubbleTitle>Critical Code</BubbleTitle>
            <GenericBubble
              letter={contractCriticalCode[selectedReactiveJob.CriticalStatus] != undefined? contractCriticalCode[selectedReactiveJob.CriticalStatus].CriticalCode:''}
              text={contractCriticalCode[selectedReactiveJob.CriticalStatus]!= undefined? contractCriticalCode[selectedReactiveJob.CriticalStatus].Details: ''}
            />
          </div>
        </BubbleSection>
        <AssetDetailList>
          <SectionTitle>Asset Details</SectionTitle>
          <ApiStatus status={currentApiStatus} type="bar">
            <JobDetailAssetCardList assetList={renderedAsset} location="reactive" />
          </ApiStatus>
        </AssetDetailList>
        <div>
          <SectionTitle>Job details</SectionTitle>
          <DetailsTable headings={tableHeadings} tableData={selectedReactiveJob} />
        </div>
        <ButtonCtn>
          <ExportButton data={selectedReactiveJob} columns={Object.values(tableHeadings)}/>
        </ButtonCtn>
      </ContentCtn>
    </JobDetailCtn>
  );
};

export default JobDetailReactive;
